import SimpleHeaderSection from 'sections/SimpleHeader';
import MenuHeaderSection from 'sections/MenuHeader';
import SimpleFooterSection from 'sections/SimpleFooter';
import ContactFooterSection from 'sections/ContactFooter';
import LoginSection from 'sections/Login';
import TextSection from 'sections/Text';
import DateSection from 'sections/Date';
import ImageSection from 'sections/Image';
import ButtonSection from 'sections/Button';
import IconSection from 'sections/Icon';
import FlexBoxSection from 'sections/FlexBox';
import GridsSection from 'sections/Grids';
import BreadcrumbsSection from 'sections/Breadcrumbs';
import FileUploaderSection from 'sections/FileUploader';
import UsersTableSection from 'sections/UsersTable';
import SolutionsTableSection from 'sections/SolutionsTable';
import DynamicTableListViewSection from 'sections/DynamicTableListView';
import DynamicTableDetailViewSection from 'sections/DynamicTableDetailView';
import DynamicTableAttributeViewSection from 'sections/DynamicTableAttributeView';
import EditCollectionFormSection from 'sections/EditCollectionForm';
import CollectionBreadcrumbsSection from 'sections/CollectionBreadcrumbs';
import EditSolutionSection from 'sections/EditSolution';
import AppListViewSection from 'sections/AppListView';
import AppCreateSection from 'sections/AppCreate';
import EditUserSection from 'sections/EditUser';
import EditInputsFormSection from 'sections/EditInputsForm';
import TwoButtonCallApiSection from 'sections/TwoButtonCallApi';
import BusinessLogicListViewSection from 'sections/BusinessLogicListView';
import BusinessLogicCreateSection from 'sections/BusinessLogicCreate';
import BusinessLogicEditSection from 'sections/BusinessLogicEdit';
import EventTriggerEditSection from 'sections/EventTriggerEdit';
import EventTriggerCreateSection from 'sections/EventTriggerCreate';
import HandlerCreateSection from 'sections/HandlerCreate';
import HandlerEditSection from 'sections/HandlerEdit';
import SignalCreateSection from 'sections/SignalCreate';
import SignalEditSection from 'sections/SignalEdit';
import HandlerParameterCreateSection from 'sections/HandlerParameterCreate';
import HandlerParameterEditSection from 'sections/HandlerParameterEdit';
import BreadcrumbHeaderSection from 'sections/BreadcrumbHeader';
import BannerSection from 'sections/Banner';
import MapSection from 'sections/Map';
import HeaderNavbarSection from 'sections/HeaderNavbar';
import AccordionSection from 'sections/Accordion';
import MetadataSection from 'sections/Metadata';
import TextFromApiSection from 'sections/TextFromApi';
import CollapseBoxSection from 'sections/CollapseBox';
import ForgetPasswordSection from 'sections/ForgetPassword';
import ResetPasswordSection from 'sections/ResetPassword';
import ContactFormSection from 'sections/ContactForm';
import CarouselSection from 'sections/Carousel';
import ImageWithLink from 'sections/ImageWithLink';
import FloatingIcon from 'sections/FloatingIcon';
import RichTextSection from 'sections/RichText';
import ChooseProjectSection from './ChooseProject';
import EditPageSection from './EditPageComponents';
import SettingsSection from './Settings';
import WebpageDashboardSection from './WebpagesDashboard';
import AppSummarySection from './AppSummarySection';
import PageSummarySection from './PageSummarySection';
import AppSummaryAddPageSection from './AppSummaryAddPage';
import VideoPlayerSection from './VideoPlayer';
import SurveysSection from './Survey';
import SurveySection from './Survey/survey';
import SurveyCreate from './Survey/EditSurvey';
import SurveyFormSubmitSection from './SurveyFormSection';
import GoogleTranslateButtonSection from './GoogleTranslateButton';
import BuddhistLoginSection from './BuddhistLogin';
import BuddhistContactTableSection from './BuddhistContactTable';
import ActivityTableSection from './ActivityTable';
import BuddhistPageFooterSection from './BuddhistPageFooter';
import BuddhistPageHeaderSection from './BuddhistPageHeader';
import WatchOnePageHeaderSection from './WatchOnePageHeader';
import SetPasswordSection from './SetPassword';
import TrackingDashboardSection from './TrackingDashboard';
import ConfigurationsTableSection from './ConfigurableTable';
import EditConfigurationSection from './EditConfiguration';
import TrackingDashboardHeaderSection from './TrackingDashboardHeader';
import WhatsappLogSection from './WhatsappLog';
import WatchOneMobileHeaderSection from './WatchOneMobileHeader';
import EditProfileSection from './EditProfile';
import ProductListSection from './ProductList';
import ContactDetailSection from './ContactDetail';
import JsonAttributesTableSection from './JsonAttributesTable';
import EditMonitorSection from './EditMonitor';
import MonitorItemTableSection from './MonitorItemTable';
import UserProductListSection from './UserProductList';
import EditBrandSection from './EditBrand';
import WatchOneModelTableSection from './WatchOneModelTable';
import EditModelSection from './EditModel';
import EditContactSection from './EditContact';
import AlertTableSection from './AlertTable';
import AlertDetailSection from './AlertDetail';
import ImportModelSection from './ImportModel';
import UninterestedProductListSection from './UninterestedProductList';
import RawMessageDetailSection from './RawMessageDetail';
import WhatsappSourceAccountListSection from './WhatsappSourceAccountList';
import WhatsappSourceAccountGroupListSection from './WhatsappSourceAccountGroupList';
import ProductStatisticListSection from './ProductStatisticList';

export const sectionDefinitionComponentMapping = {
  '25310d81-d558-40a8-bac5-18be605cae8f': SimpleHeaderSection,
  '092b2173-d14f-4f94-998c-0470cc0d6577': MenuHeaderSection,
  'a32667b8-22a4-4efe-9986-16877aa9076a': SimpleFooterSection,
  '5234c831-83fc-4e57-879d-b45ea6e18120': ContactFooterSection,
  '7b7002a2-bcc1-4ba5-a12f-8e6b9af7cc78': LoginSection,
  '656bb778-f965-457d-8f79-9e5aaaeda369': TextSection,
  '49daf9ec-f5d2-4cbf-af3f-d88291c1d907': DateSection,
  '0187cbe3-eaba-44a4-bd2d-0393c20f99b3': ImageSection,
  'dc5ed9fd-fcff-4320-81bc-f1b4ee55e637': ButtonSection,
  '42de2900-6bfb-442f-ac99-ce8e373b131d': IconSection,
  '2f9195b1-6c86-448a-8bf2-74196c8e8788': FlexBoxSection,
  'a56b67a1-f366-4891-b89e-8b275e33e7a4': GridsSection,
  '23ed1cc0-2376-4d52-8719-5e0344ebd3ae': BreadcrumbsSection,
  '11317177-6f1f-4859-976a-0347c6750740': FileUploaderSection,
  '7065ea00-46eb-4426-bb55-a5ed9bc5dc32': UsersTableSection,
  'b8344014-a62d-47ac-abd1-5b81427e95c6': SolutionsTableSection,
  'a328c693-fdb4-47a5-80f2-5133cdd55517': DynamicTableListViewSection,
  '08f9d734-9822-4ee8-a65d-7c73ab93d164': DynamicTableDetailViewSection,
  '5f517188-8cc9-4a46-810a-344ab73d7b87': DynamicTableAttributeViewSection,
  'fee5da64-84a8-4d8e-b743-09398979bed2': EditCollectionFormSection,
  '72f7d214-9c7a-4b69-b7ce-7562fb1c9b6a': CollectionBreadcrumbsSection,
  '5fb3219c-e8c0-4c72-8981-13bc53bdb66e': EditSolutionSection,
  '0e19f2f7-e35e-4dc3-bdac-ae1efe210bcc': AppListViewSection,
  '7a9ab307-7e4e-4cc0-adae-8c0be3f800b2': AppCreateSection,
  'ba83f9cc-20a9-4f2a-bdde-45caf9efac49': EditUserSection,
  'f522b59f-7bfd-4b6f-acfe-e259b91440d3': EditInputsFormSection, // 1 Inputs
  'c9373cfd-26b5-4bc4-8add-c8987f0a15a4': EditInputsFormSection, // 2 Inputs
  '1ec17af6-5f56-4fa3-8343-027d017c5342': EditInputsFormSection, // 3 Inputs
  '6a75bb25-1492-48e8-80a2-e1678e424acb': EditInputsFormSection, // 4 Inputs
  '83b00d21-f824-44bb-9313-b295ed35210f': TwoButtonCallApiSection,
  'bc503c6d-a3cb-4da7-b998-7e8b1e5a688f': BusinessLogicListViewSection,
  '60857454-31a9-4430-9596-2b74bc921fef': BusinessLogicCreateSection,
  'c67b06ab-2ecc-4f8c-b078-ebd5afa25264': BusinessLogicEditSection,
  'e02b0681-7bd0-43a4-b5fb-8e986ddb60e4': EventTriggerCreateSection,
  'def77128-42c1-4855-a1e0-d449f47ffdd2': EventTriggerEditSection,
  '6bd3f2b5-bd32-45aa-b6a8-ecdef08b92fa': HandlerCreateSection,
  '651c607d-4eab-4f05-958e-dede8f422aff': HandlerEditSection,
  '29cb023d-3138-4242-88bf-054ac7206568': SignalCreateSection,
  '545dbb6f-fc3b-4586-8b91-7157fcb4f5b9': SignalEditSection,
  'ca9d59b1-11ac-4f70-b9a1-ce11fe90d6ee': HandlerParameterCreateSection,
  '1e561303-5326-442b-9806-d70b08f63a15': HandlerParameterEditSection,
  '7a57def6-64e2-4bd9-a2bb-01ced8e6afad': BreadcrumbHeaderSection,
  '0910c381-fb71-4e25-968b-c0bb6cd93e1a': BannerSection,
  'db5ddb16-b545-4a19-a56a-de55bbd743cc': MapSection,
  'd0486481-7162-4b0c-b3b5-86b2e348cfec': HeaderNavbarSection,
  '039e5a9f-4f38-4fff-8c21-b4bc19967504': AccordionSection,
  '35e71e6a-dd84-4356-b0e1-dd63c93b4b27': MetadataSection,
  'c112b083-d358-43b1-945c-5dee2ba8a872': TextFromApiSection,
  '4e88f276-5d9b-40d5-bc32-51e1b67d735c': CollapseBoxSection,
  '9fe3edf1-d978-4bb5-9d93-d4db6de7d508': ForgetPasswordSection,
  '018d45de-58ef-797c-8515-873dbd879ef7': ResetPasswordSection,
  'b8dd4b12-1d9f-46d7-8621-b972598a0f6a': ContactFormSection,
  '6003e507-b89b-4205-8fe7-23c8dd26d13f': CarouselSection,
  '2ff5acd9-6a46-4e3a-9321-3f2099a8aa19': ImageWithLink,
  '120d543c-3174-4e32-bbac-413dc1a92be5': FloatingIcon,
  '48ec46f1-d586-417a-9c0c-b636b2c5da05': RichTextSection,
  '0f554403-0683-4f72-b43d-8b8b80445e40': ChooseProjectSection,
  'e2d5e514-40e8-4f22-837e-8b91459deca8': EditPageSection,
  'cf46b75e-8c00-4ef0-8f65-db6857650041': SettingsSection,
  '66eef0b7-a45e-4fc7-8f7a-9e527fbab4dd': WebpageDashboardSection,
  '047701ba-e7ed-4740-850d-a7984f97d2cc': AppSummarySection,
  '6021aa30-0fbc-437d-89a3-18678e716e56': PageSummarySection,
  '83b6bdcc-14e0-4f27-9d10-f09ab444b945': AppSummaryAddPageSection,
  '189ddc8c-af93-4984-a446-75aaef049995': VideoPlayerSection,
  'b95edbd0-84c8-4c7d-8308-d84b757e27e6': SurveysSection,
  '807e6720-582b-489f-87f1-de49acf9c7a4': SurveySection,
  'add05100-10b1-46b9-9081-66b923f2be95': SurveyCreate,
  'e5aa9437-5be6-4920-a74f-728f00b30024': SurveyFormSubmitSection,
  '018ee17b-6a6b-742e-bbf3-0930f30cfd85': GoogleTranslateButtonSection,
  '0195b74d-1497-7325-aa1b-dbab60304d4e': BuddhistPageHeaderSection,
  '0195b74d-96cc-7a77-83ef-bbe971966858': BuddhistPageFooterSection,
  '0195b856-0d7d-77a7-9ce7-3d53e1d02f48': BuddhistLoginSection,
  '0195cce9-57b5-7b13-9eea-c05bcd3caf2e': BuddhistContactTableSection,
  '0195d6a5-0fce-7766-a66a-40a2b5a7a98d': ActivityTableSection,
  '0195f505-9869-7318-8cd8-d2f09a908323': WatchOnePageHeaderSection,
  '018e5656-f165-7f37-9432-09498b7cf90a': SetPasswordSection,
  '0195fadf-704b-7717-9304-3247d3c81fea': TrackingDashboardSection,
  '01960eae-7caa-7101-98ae-638f2d7671be': ConfigurationsTableSection,
  '01960f14-c503-7d98-bef3-46ffea1ca2ad': EditConfigurationSection,
  '01961902-3c41-7238-9bc7-bb56bfac8139': TrackingDashboardHeaderSection,
  '01961f26-8f66-790d-b7de-e020ca293545': WhatsappLogSection,
  '01966150-f5e6-7273-b28d-acd5643f3454': WatchOneMobileHeaderSection,
  '01966637-a209-7376-a7f3-0886ff2147e3': EditProfileSection,
  '01966b6d-7d3e-70b8-b46d-c802edafead9': ProductListSection,
  '01966c73-a06b-7757-b329-a0484fdf7954': ContactDetailSection,
  '01967b75-6da7-7260-acbf-4028f2caeadd': JsonAttributesTableSection,
  '01968041-155d-7e84-a8dc-eb95e11dc4c6': EditMonitorSection,
  '01968101-9b9f-7c54-9ed2-28bcea378c56': MonitorItemTableSection,
  '0196813a-e114-74c2-90c2-0aee8767d39c': UserProductListSection,
  '01969055-ffae-7e80-90c2-edf1a1ebe640': EditBrandSection,
  '01969096-2315-7e88-9215-4fbab9be566e': WatchOneModelTableSection,
  '019690c2-be65-78db-94ce-8c93c36507c7': EditModelSection,
  '0196a420-2409-7333-812b-837adbae0117': EditContactSection,
  '0196a47c-33cd-759c-8d98-26deadaf8797': AlertTableSection,
  '0196a4c7-8295-7f24-8d5b-55efe42b8b74': AlertDetailSection,
  '0196f6e4-016a-7031-a58a-126be58cebf5': ImportModelSection,
  '01978bf2-f926-7c8e-8a4c-87ddbd99b0be': UninterestedProductListSection,
  '0198f5b2-cfd0-73c5-a8de-a39d1351080e': RawMessageDetailSection,
  '52171f56-bcd0-4fcc-915a-5518b4054425': WhatsappSourceAccountListSection,
  '8a5755be-3907-446a-aa20-d552aaf5a333': WhatsappSourceAccountGroupListSection,
  '655b15f2-c7ed-4bfc-b298-ee7b7239f875': ProductStatisticListSection,
};
